import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["apiClient", "engagementId", "subjectObjectId", "subjectObjectIds", "subjectObjectTypeId", "onDefaultAssociationsLoaded", "associationRecords", "engagementOrInteractionType", "isError", "isLoading"];
import { useEffect } from 'react';
import usePrevious from 'react-utils/hooks/usePrevious';
import UniversalAssociationsSelect from './UniversalAssociationsSelect';
import { useUniversalAssociations } from '../hooks';
import { OrderedMap } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
function UniversalAssociationsSelectV2(_ref) {
  let {
      apiClient,
      engagementId,
      subjectObjectId,
      subjectObjectIds,
      subjectObjectTypeId,
      onDefaultAssociationsLoaded,
      // v1 props
      associationRecords: overriddenAssociationRecords,
      engagementOrInteractionType,
      isError,
      isLoading
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    associationRecords: universalAssociationRecords,
    isLoading: isUniversalAssociationRecordsLoading,
    isError: isUniversalAssociationRecordsError
  } = useUniversalAssociations({
    apiClient,
    engagementId,
    engagementType: engagementOrInteractionType,
    subjectObjectId,
    subjectObjectIds,
    subjectObjectTypeId
  });
  const previousAssociations = usePrevious(universalAssociationRecords) || OrderedMap();
  const previousError = usePrevious(isUniversalAssociationRecordsError);
  useEffect(() => {
    if (onDefaultAssociationsLoaded) {
      if (isUniversalAssociationRecordsError && !previousError) {
        onDefaultAssociationsLoaded(null);
      } else if (!isUniversalAssociationRecordsLoading && !universalAssociationRecords.equals(previousAssociations)) {
        onDefaultAssociationsLoaded(universalAssociationRecords);
      }
    }
  }, [isUniversalAssociationRecordsError, isUniversalAssociationRecordsLoading, onDefaultAssociationsLoaded, previousAssociations, previousError, universalAssociationRecords]);
  const associationRecords = overriddenAssociationRecords && overriddenAssociationRecords.size ? overriddenAssociationRecords : universalAssociationRecords;
  return /*#__PURE__*/_jsx(UniversalAssociationsSelect, Object.assign({
    associationRecords: associationRecords,
    engagementOrInteractionType: engagementOrInteractionType,
    isError: isError !== undefined ? isError : isUniversalAssociationRecordsError,
    isLoading: isLoading !== undefined ? isLoading : isUniversalAssociationRecordsLoading
  }, rest));
}

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UniversalAssociationsSelectV2.defaultProps = Object.assign({}, UniversalAssociationsSelect.defaultProps, {
  // if we don't explicitly set these to undefined, the default values of false from v1 will be used
  // and isError and isLoading will always be false when we pass them to v1
  isLoading: undefined,
  isError: undefined
});
export default UniversalAssociationsSelectV2;